import React from "react";
import { useTranslation } from "react-i18next";
import iconUserChecked from "../../assets/img/icon-user-cheked.svg";

import styles from "./UserRoleBudge.module.scss";

type Props = {
  role: string;
};

const UserRoleBudge: React.FC<Props> = (props) => {
  const { role } = props;
  const { t } = useTranslation();

  return (
    <>
      {role !== "general_user" ? (
        <li className={styles["p-userRole"]}>
          <img src={iconUserChecked} className={styles["p-userRole__icon"]} />
          <div className={styles["p-userRole__name"]}>{t(`roles.${role}`)}</div>
        </li>
      ) : null}
    </>
  );
};

export default UserRoleBudge;
